import {
  ETAT_SANSSUITE,
  ETAT_CLOTURER,
} from '@/configuration/devisConf';
import i18n from '@/i18n';

export default function checkSiCommandeSignable(commande, societe) {
  const causesNonSignable = [];

  // Vérifier si l'état est différent de sans suite ou clos
  if (commande.etat === ETAT_SANSSUITE || commande.etat === ETAT_CLOTURER) {
    causesNonSignable.push(i18n.t('detail.dcfSignable.etatDifferentSansSuiteOuClos'));
  }

  if (commande.intervenants.filter(intervenant => intervenant.donneurOrdre).length !== 1) {
    causesNonSignable.push(i18n.t('detail.dcfSignable.donneurdOrdeRequis'));
  }

  if (!societe.signatureElectroniqueReferenceExterne || !societe.signatureElectroniqueToken) {
    causesNonSignable.push(i18n.t('detail.dcfSignable.signatureImpossible'));
  }

  return causesNonSignable;
}
